require('select2/dist/js/select2.full');

function set_values_to_hidden_fields(location_id, location_country_alpha3_code, state, county) {
  jQuery_custom('#travel_check_travel_check_form_location_id').val(location_id);
  jQuery_custom('#travel_check_travel_check_form_location_country_alpha3_code').val(location_country_alpha3_code);
  jQuery_custom('#travel_check_travel_check_form_search_state').val(state);
  jQuery_custom('#travel_check_travel_check_form_search_county').val(county);
}

function search(query, callback) {
  var params = {
    q: query.term,
    limit: 10,
    types: "area",
    lang: "de",
    apiKey: "_KW7JJPELxsR7Gq95E--BG1E0_iWkPIGhImTYwADXcg",
  };

  jQuery_custom.getJSON("https://autocomplete.search.hereapi.com/v1/autocomplete?" + jQuery_custom.param(params), function (data) {
    var addresses = [];

    data.items.forEach(function (address, index) {
      if(index == 0) {
        setLocation(address.id, address.countryCode)
      }
      addresses.push(
        {
          title: address.title,
          value: address.title,
          id: address.id,
          countryCode: address.address.countryCode,
          state: address.address.state,
        });
    });

    return callback(addresses);
  });
}

function setLocation(locationId, countryCode) {
  var params = {
    id: locationId,
    lang: "de",
    apiKey: "_KW7JJPELxsR7Gq95E--BG1E0_iWkPIGhImTYwADXcg",
  };
  var dictionary = {};

  jQuery_custom.ajax({
    url: "https://lookup.search.hereapi.com/v1/lookup?" + jQuery_custom.param(params),
    async: true,
    dataType: 'json',
    success: function (result) {
      if(result) {
        dictionary = result.address;
        set_values_to_hidden_fields(locationId, result.address.countryCode, result.address.state, result.address.county);
      }
      else {
        set_values_to_hidden_fields(locationId, countryCode, '', '');
      }
    }
  });
  return dictionary;
}

jQuery_custom(() => {
  $('#travel_check_form_country_code').select2({ theme: 'bootstrap', language: 'de' });

  jQuery_custom("#travel_check_travel_check_form_term").autocomplete({
    source: search,
    minLength: 2,
    select: function (event, ui) {
      setLocation(ui.item.id, ui.item.countryCode);
    }
  });

  jQuery_custom('#travel_check_travel_check_form_term').on('input', function() {
    jQuery_custom('#travel_check_travel_check_form_region_code').val('');
    jQuery_custom('#travel_check_form_country_code').val('');
  });

  jQuery_custom('#travel_check_travel_check_form_term').click(function() {
    jQuery_custom('#travel_check_travel_check_form_region_code').val('');
    jQuery_custom('#travel_check_form_country_code').val('');
  });

  jQuery_custom('#travel_check_form_country_code').change(function(){
    jQuery_custom('#travel_check_travel_check_form_term').val('');
    jQuery_custom('#travel_check_travel_check_form_search_state').val('');
    jQuery_custom('#travel_check_travel_check_form_search_county').val('');
    jQuery_custom('#travel_check_travel_check_form_location_id').val('');
    jQuery_custom('#travel_check_travel_check_form_region_code').val('');
    jQuery_custom('#travel_check_travel_check_form_location_country_alpha3_code').val('');
  });

  jQuery_custom('#region_select').change(function() {
    jQuery_custom('#travel_check_travel_check_form_region_code').val(jQuery_custom(this).val());
    jQuery_custom('#travel_check_travel_check_form_location_id').val('');
    jQuery_custom('#new_travel_check\\/travel_check_form').submit();
  });

  jQuery_custom( document ).ready(function() {
    var divLoc = jQuery_custom('#map').offset();
    jQuery_custom('html, body').animate({scrollTop: divLoc.top}, "slow");
  });
})
